import { render, staticRenderFns } from "./SelectEstate.vue?vue&type=template&id=58c47f52&"
import script from "./SelectEstate.vue?vue&type=script&lang=js&"
export * from "./SelectEstate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports